import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import './index.scss';
import './assets/css/style_custom.css'
import App from './components/app';
import { ScrollContext } from 'react-router-scroll-4';

// Components
import Dashboard from './components/dashboard';

// Products physical
import Category from './components/products/physical/category';
import Sub_category from './components/products/physical/sub-category';
import Product_list from './components/products/physical/product-list';
import Add_product from './components/products/physical/add-product';
import Product_detail from './components/products/physical/product-detail';

//Product Digital
import Digital_parent_category from './components/products/digital/digital-parent-category';
import Digital_category from './components/products/digital/digital-category';
import Digital_sub_category from './components/products/digital/digital-sub-category';
import Edit_category from './components/products/digital/edit-category';
import Edit_parent_category from './components/products/digital/edit-parent-category';
import Edit_subcategory from './components/products/digital/edit-subcategory';
import Edit_product from './components/products/digital/edit-product';
import Digital_pro_list from './components/products/digital/digital-pro-list';
import Digital_add_pro from './components/products/digital/digital-add-pro';
import InvoiceReport from './components/reports/invoiceReport'

//Sales
import Orders from './components/sales/orders';
import Transactions_sales from './components/sales/transactions-sales';
import View_order from './components/sales/view-order';
//Coupons
import ListCoupons from './components/coupons/list-coupons';
import Create_coupons from './components/coupons/create-coupons';

//Pages
import ListPages from './components/pages/list-page';
import Create_page from './components/pages/create-page';
import Media from './components/media/media';
import List_menu from './components/menus/list-menu';
import Create_menu from './components/menus/create-menu';
import List_user from './components/users/list-user';
import UserListSession from './components/users/userListSession';
import Create_user from './components/users/create-user';
import List_vendors from './components/vendors/list-vendors';
import Create_vendors from './components/vendors/create.vendors';
import Translations from './components/localization/translations';
import Rates from './components/localization/rates';
import Taxes from './components/localization/taxes';
import Profile from './components/settings/profile';
import Reports from './components/reports/report';
import Invoice from './components/invoice';
import Datatable from './components/common/datatable'
import Login from './components/auth/login';
import Mcq_Master from './components/mcqMaster/mcqlist';
import Milestone_Master from './components/mcqMaster/milestone';
import AddZipCourses from './components/products/digital/add-zip-courses';
import Banner from './components/settings/banner';
import openReport from './components/users/userInfo'
import FullReport from './components/users/report'
import NotFound from './components/NotFound';
window.baseUrl = "http://localhost:8005"

var userInfo = localStorage.getItem('userInfo');

class Root extends Component {  
    
    render() {
        return (
            <BrowserRouter basename={'/admin'}>
                <ScrollContext>
                    
                        { !userInfo ? 
                        <> 
                        <Switch>
                            <Route exact path={`${process.env.PUBLIC_URL}/`} component={Login} />
                            <Route exact path={`${process.env.PUBLIC_URL}/login`} component={Login} />
                            <Route exact path={`${process.env.PUBLIC_URL}/auth/login`} component={Login} />
                            <Route path={`${process.env.PUBLIC_URL}/NotFound`} component={NotFound} />
                            <Redirect to="/NotFound" />
                        </Switch>
                        </>
                        : 
                        
                        <App>
                            <Switch>
                            <Route exact path={`${process.env.PUBLIC_URL}/`} component={Dashboard} />
                            <Route  path={`${process.env.PUBLIC_URL}/dashboard`} component={Dashboard} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/physical/category`} component={Category} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/physical/sub-category`} component={Sub_category} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/physical/product-list`} component={Product_list} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/physical/product-detail`} component={Product_detail} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/physical/add-product`} component={Add_product} />
                            
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/digital-parent-category`} component={Digital_parent_category} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/digital-category`} component={Digital_category} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/digital-sub-category`} component={Digital_sub_category} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/digital-product-list`} component={Digital_pro_list} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/digital-add-product`} component={Digital_add_pro} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/edit-category`} component={Edit_category} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/edit-parent-category`} component={Edit_parent_category} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/edit-subcategory`} component={Edit_subcategory} />
                            <Route  path={`${process.env.PUBLIC_URL}/products/digital/edit-product`} component={Edit_product} />
                            <Route  path={`${process.env.PUBLIC_URL}/reports/invoiceReport`} component={InvoiceReport} />

                            <Route  path={`${process.env.PUBLIC_URL}/sales/orders`} component={Orders} />
                            <Route  path={`${process.env.PUBLIC_URL}/sales/transactions`} component={Transactions_sales} />
                            <Route  path={`${process.env.PUBLIC_URL}/sales/view-order`} component={View_order} />

                            <Route  path={`${process.env.PUBLIC_URL}/coupons/list-coupons`} component={ListCoupons} />
                            <Route  path={`${process.env.PUBLIC_URL}/coupons/create-coupons`} component={Create_coupons} />

                            <Route  path={`${process.env.PUBLIC_URL}/pages/list-page`} component={ListPages} />
                            <Route  path={`${process.env.PUBLIC_URL}/pages/create-page`} component={Create_page} />

                            <Route  path={`${process.env.PUBLIC_URL}/media`} component={Media} />

                            <Route  path={`${process.env.PUBLIC_URL}/menus/list-menu`} component={List_menu} />
                            <Route  path={`${process.env.PUBLIC_URL}/menus/create-menu`} component={Create_menu} />

                            <Route  path={`${process.env.PUBLIC_URL}/users/list-user`} component={List_user} />
                            <Route  path={`${process.env.PUBLIC_URL}/users/create-user`} component={Create_user} />
                         
                            <Route path={`${process.env.PUBLIC_URL}/openreport`} component={openReport} />
                            <Route path={`${process.env.PUBLIC_URL}/report`} component={FullReport} />

                            <Route path={`${process.env.PUBLIC_URL}/vendors/list_vendors`} component={List_vendors} />
                            <Route path={`${process.env.PUBLIC_URL}/vendors/create-vendors`} component={Create_vendors} />

                            <Route path={`${process.env.PUBLIC_URL}/localization/transactions`} component={Translations} />
                            <Route path={`${process.env.PUBLIC_URL}/localization/currency-rates`} component={Rates} />
                            <Route path={`${process.env.PUBLIC_URL}/localization/taxes`} component={Taxes} />

                            <Route path={`${process.env.PUBLIC_URL}/reports/report`} component={Reports} />

                            <Route path={`${process.env.PUBLIC_URL}/settings/profile`} component={Profile} />
                            <Route path={`${process.env.PUBLIC_URL}/settings/banner`} component={Banner} />

                            <Route path={`${process.env.PUBLIC_URL}/invoice`} component={Invoice} />

                            <Route path={`${process.env.PUBLIC_URL}/data-table`} component={Datatable} />

                            <Route path={`${process.env.PUBLIC_URL}/mcqMaster`} component={Mcq_Master} />
                            <Route path={`${process.env.PUBLIC_URL}/mlilestone`} component={Milestone_Master} />
                            <Route path={`${process.env.PUBLIC_URL}/users/userSessions`} component={UserListSession} />
                            <Route path={`${process.env.PUBLIC_URL}/add-zip-courses`} component={AddZipCourses} />
                            <Route path={`${process.env.PUBLIC_URL}/NotFound`} component={NotFound} />
                                
                            <Redirect to="/NotFound" />
                            </Switch>

                            
                        </App>
                        
                        }
                </ScrollContext>
            </BrowserRouter>
        )
    }
}

ReactDOM.render(<Root />, document.getElementById('root'));

//Khanna
//Khanna
